import { ValidationRepository } from "../../repositories/ValidationRepository";
import { ValidationResponse } from "../../entities/ValidationEntity";
import { InvoiceEntity } from "../../entities/InvoiceEntity";

export class ValidateInvoiceUseCase {
  constructor(private validationRepository: ValidationRepository) {}

  async execute(
    invoiceData: any,
    invoiceDocument: InvoiceEntity,
    validationType: string = "full_validation"
  ): Promise<ValidationResponse> {
    return await this.validationRepository.validateInvoice(
      invoiceData,
      invoiceDocument,
      validationType
    );
  }
}
